import {ActivatedRouteSnapshot} from '@angular/router';

export abstract class UrlNumberParamResolverHelper {
  protected findParam(paramName: string, route: ActivatedRouteSnapshot): number {
    if (route == null) {
      return null;
    }
    if (route.paramMap.has(paramName)) {
      return +route.paramMap.get(paramName);
    }
    return this.findParam(paramName, route.parent);
  }
}
